export const categories = [
  { slug: 'tech', name: '科技数码', icon: 'ri-smartphone-line' },
  { slug: 'food', name: '食品饮料', icon: 'ri-restaurant-line' },
  { slug: 'beauty', name: '美妆护肤', icon: 'ri-magic-line' },
  { slug: 'education', name: '教育培训', icon: 'ri-book-open-line' },
  { slug: 'finance', name: '金融理财', icon: 'ri-bank-line' },
  { slug: 'health', name: '医疗健康', icon: 'ri-heart-pulse-line' },
  { slug: 'travel', name: '旅游出行', icon: 'ri-flight-takeoff-line' },
  { slug: 'home', name: '家居生活', icon: 'ri-home-gear-line' },
  { slug: 'fashion', name: '服饰鞋包', icon: 'ri-t-shirt-line' },
  { slug: 'auto', name: '汽车交通', icon: 'ri-car-line' },
  { slug: 'entertainment', name: '娱乐消费', icon: 'ri-movie-line' },
  { slug: 'ecommerce', name: '电商平台', icon: 'ri-shopping-cart-2-line' },
];